/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Api_Bridge_Toggle_AriaInputs */



/**
* | output |
* | --- |
* | "Toggle the External API for {name}" |
*
* @param {Api_Bridge_Toggle_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_toggle_aria = /** @type {((inputs: Api_Bridge_Toggle_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Toggle_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Externe API für ${i?.name} umschalten`)
	return /** @type {LocalizedString} */ (`Toggle the External API for ${i?.name}`)
});